/**
 * FindPasswordResultPresenter
 * --
 */
import React from 'react';
import { Content, Row, Col, Title } from 'components';
import { Button, Input } from 'antd';

const FindPasswordResultPresenter = ({
  onChange,
  inputValue,
  onSubmit,
  passwordRef,
  rePasswordRef,
  status,
  message,
  screenSize,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 40 : 32,
      lineHeight: '120%',
      fontWeight: 700,
      color: 'var(--black-color)',
    },

    text: {
      marginTop: screenSize >= 768 ? 20 : 12,
      fontSize: screenSize >= 768 ? 18 : 12,
      fontWeight: 400,
      lineHeight: '180%',
      color: 'var(--black-color)',
      textAlign: 'center',
    },

    button: {
      height: 58,
      fontSize: 16,
      fontWeight: 700,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    resultBox: {
      marginTop: 40,
      marginBottom: 40,
      position: 'relative',
      top: 0,
      left: 0,
    },

    input: {
      width: '100%',
      height: 44,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '180%',
    },

    message: {
      fontSize: 12,
      fontWeight: 400,
      color: 'var(--danger-color)',
      position: 'absolute',
      top: '100%',
      left: 0,
      display: status === 'default' ? 'none' : 'inline-block',
      marginTop: 8,
    },
  };

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={1820} padding={'100px 0px'}>
      <Row gutter={16}>
        <Col x={1} md={8}></Col>
        <Col x={22} md={8}>
          <Title align={'center'} style={{ ...styles.title }}>
            비밀번호 재설정
          </Title>

          <p style={{ ...styles.text }}>변경하실 비밀번호를 입력해주세요.</p>

          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              ...styles.resultBox,
            }}
          >
            <Input.Password
              ref={passwordRef}
              value={inputValue.password}
              style={{ ...styles.input, marginBottom: 20 }}
              placeholder="변경하실 비밀번호를 입력해 주세요."
              onChange={(e) => onChange('password', e.target.value)}
            />

            <Input.Password
              ref={rePasswordRef}
              value={inputValue.re_password}
              style={{ ...styles.input }}
              placeholder="비밀번호를 한번 더 입력해 주세요."
              onChange={(e) => onChange('re_password', e.target.value)}
            />

            <p
              style={{
                ...styles.message,
              }}
            >
              {message}
            </p>
          </Content>

          <Content maxWidth={'100%'} padding={0}>
            <Button
              style={{
                ...styles.button,
                marginTop: screenSize >= 768 ? 80 : 40,
              }}
              onClick={() => onSubmit()}
            >
              비밀번호 재설정
            </Button>
          </Content>
        </Col>
        <Col x={1} md={8}></Col>
      </Row>
    </Content>
  );
};

export default FindPasswordResultPresenter;
